var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-between align-center"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.size)+" ("+_vm._s(_vm.symbol)+")")])]),_c('btn-incrementer',{model:{value:(_vm.count),callback:function ($$v) {_vm.count=$$v},expression:"count"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }